import React, { useEffect, useState } from "react";

const etapas = [
  { rotulo: "Pedido enviado", detalhe: "#8830 · 7 itens no carrinho" },
  { rotulo: "Pagamento confirmado", detalhe: "PIX · R$ 6.284,00" },
  { rotulo: "Pedido aprovado", detalhe: "Vale Verde" },
  { rotulo: "Itens em separação", detalhe: "Unidade Rondonópolis" },
  { rotulo: "A caminho", detalhe: "Entrega na Fazenda Santa Helena" },
];

const canais = [
  {
    titulo: "Status do pedido",
    texto:
      "Cada mudança de etapa aparece no app na hora em que o parceiro registra, sem você precisar atualizar a tela.",
  },
  {
    titulo: "Confirmação de pagamento",
    texto:
      "Assim que o PIX ou o boleto é reconhecido, o pedido muda de estado e o recibo entra no histórico.",
  },
  {
    titulo: "Conversa com o parceiro",
    texto:
      "Mensagem chega na hora, e você vê quando o outro lado está digitando.",
  },
  {
    titulo: "Devolução",
    texto:
      "Abriu a solicitação, cada resposta do parceiro chega como atualização, não como e-mail perdido.",
  },
];

const TempoReal: React.FC = () => {
  const [ativa, setAtiva] = useState(etapas.length - 1);

  useEffect(() => {
    const reduced =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;

    setAtiva(0);
    let i = 0;
    const t = window.setInterval(() => {
      i = (i + 1) % (etapas.length + 2);
      setAtiva(Math.min(i, etapas.length - 1));
    }, 1500);
    return () => window.clearInterval(t);
  }, []);

  return (
    <section className="border-b border-bone-300 bg-bone">
      <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-16">
          <div>
            <p className="eyebrow">Em tempo real</p>
            <h2 className="mt-4 font-display text-display-md font-bold text-soil">
              O pedido avisa.
              <br />
              Você não pergunta.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-soil/75">
              O app mantém conexão aberta com a plataforma. Quando o parceiro
              muda alguma coisa no pedido, muda na sua tela no mesmo instante.
            </p>

            <dl className="mt-9 grid gap-6 sm:grid-cols-2">
              {canais.map((c) => (
                <div key={c.titulo}>
                  <dt className="font-display text-base font-bold text-soil">
                    {c.titulo}
                  </dt>
                  <dd className="mt-1.5 text-sm leading-relaxed text-soil/70">
                    {c.texto}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="panel self-start">
            <div className="panel-head">
              <span className="font-mono text-[0.6875rem] uppercase tracking-[0.16em] text-soil/60">
                Pedido #8830
              </span>
              <span className="rounded border border-bone-300 bg-bone px-1.5 py-0.5 font-mono text-[0.625rem] uppercase tracking-[0.12em] text-soil/45">
                exemplo
              </span>
            </div>

            <ol className="px-4 py-2 sm:px-5">
              {etapas.map((e, i) => {
                const feita = i <= ativa;
                const atual = i === ativa;
                const ultima = i === etapas.length - 1;
                return (
                  <li key={e.rotulo} className="flex gap-4">
                    <div className="flex flex-col items-center pt-4">
                      <span
                        className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 transition-colors duration-500 ${
                          feita
                            ? "border-agro-accent bg-agro-accent"
                            : "border-bone-300 bg-white"
                        }`}
                      >
                        {feita && (
                          <svg width="9" height="9" viewBox="0 0 10 10" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M2 5.2l2 2L8 3" />
                          </svg>
                        )}
                      </span>
                      {!ultima && (
                        <span
                          className={`w-0.5 flex-1 transition-colors duration-500 ${
                            i < ativa ? "bg-agro-accent" : "bg-bone-300"
                          }`}
                        />
                      )}
                    </div>
                    <div className={`min-w-0 flex-1 py-4 ${ultima ? "" : "border-b border-bone-200"}`}>
                      <p
                        className={`text-sm font-semibold transition-colors duration-500 ${
                          feita ? "text-soil" : "text-soil/35"
                        }`}
                      >
                        {e.rotulo}
                        {atual && (
                          <span className="ml-2 whitespace-nowrap rounded bg-agro-lighter px-1.5 py-0.5 font-mono text-[0.5625rem] font-semibold uppercase tracking-[0.1em] text-agro-primary">
                            agora
                          </span>
                        )}
                      </p>
                      <p
                        className={`mt-0.5 text-xs transition-colors duration-500 ${
                          feita ? "text-soil/55" : "text-soil/25"
                        }`}
                      >
                        {e.detalhe}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TempoReal;
